<template>
    <h2><icon name="spinner" spin></icon> {{ text }}</h2>
</template>

<script>
export default {
  name: 'template',
  props: {
      text: {
          type: String,
          default: "Loading..."
      }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// Loading.vue?7dd5e796